import styled from 'styled-components'

import { Button } from '@blade/ui-kit'

export const AuthButtonSocial = styled(Button).attrs((props) => ({
  ...props,
  radius: 'rounded',
  variant: 'secondary',
  size: 'h40',
}))`
  color: var(--text-12);

  &:hover:not(:disabled) {
    background: rgba(122, 176, 173, 0.2);
  }
`
